export const formatCurrency = new Intl.NumberFormat('en-US')

export const formatPrice = price => {
  if (!price) return price
  return formatCurrency.format(Math.round(price))
}
